export const LATEST_NOTIFICATION_ID = 1;
